/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./EnContact.css";
import { Link } from "react-router-dom";
import { renderHomePageHeader } from "../../assets/component/renderHomePageHeader.js";
import { Helmet } from "react-helmet";
import HomepageMenuEn from "../../assets/component/HomepageMenuEn/HomepageMenuEn.js";

class EnContact extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
    };
    this.showModal = this.showModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  showModal() {
    this.setState({
      showModal: true,
    });
  }

  closeModal() {
    this.setState({
      showModal: false,
    });
  }

  render() {
    return (
      <div className="EnContact-view">
        <Helmet>
          <title>Contact - CheckPlus</title>
        </Helmet>
        {!!this.state.showModal && (
          <HomepageMenuEn closeModal={this.closeModal} />
        )}
        {renderHomePageHeader(this)}

        <div className="EnContact-first">
          <div className="EnContact-heading">Contact Us</div>

          <div className="EnContact-centerContainer">
            <a className="EnContact-option" href="mailto:help@check.plus">
              <div className="EnContact-pic">
                <div className="EnContact-email"></div>
              </div>
              <div className="EnContact-name">
                <strong>Email</strong>
              </div>
            </a>

            <a
              className="EnContact-option"
              href="https://wa.me/message/WJ4IE7JQ2FTMP1"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="EnContact-pic">
                <div className="EnContact-qr"></div>
              </div>
              <div className="EnContact-name">
                <strong>WhatsApp</strong>
              </div>
            </a>
          </div>
        </div>

        <div className="EnContact-footer">
          <div className="EnContact-footerNav">
            <Link to="/EnTeam">
              <div className="EnContact-footerNavItem">Our Founders</div>
            </Link>
            <Link to="/EnFaq">
              <div className="EnContact-footerNavItem">FAQ</div>
            </Link>
            <Link to="/EnContact">
              <div className="EnContact-footerNavItem">Contact Us</div>
            </Link>

            <Link to="/EnPrivacyPolicy">
              <div className="EnContact-footerNavItem">Privacy Policy</div>
            </Link>

            <Link to="/EnTerms">
              <div className="En-footerNavItem">Terms and Conditions</div>
            </Link>
          </div>

          <div className="EnContact-footer_text">
            Flat A, 5/F, Wah Lee Industrial Building
            <br />
            11 Sze Shan Street, Yau Tong, Kowloon, Hong Kong
            <br />
            <p />
            Copyright © 2026 CheckPlus Ltd. All Rights Reserved.
          </div>
        </div>
      </div>
    );
  }
}

export default EnContact;
